import { Buffer } from 'buffer'

// exceljs 在浏览器里需要全局 Buffer（Node 侧天然有，浏览器没有）
const g = globalThis as unknown as { Buffer?: typeof Buffer }
if (g.Buffer === undefined) g.Buffer = Buffer